__turbopack_context__.v({
  "code": "CodeBlock-module__S9WBGq__code",
  "codeBlock": "CodeBlock-module__S9WBGq__codeBlock",
  "filename": "CodeBlock-module__S9WBGq__filename",
});
